import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'controls'
import { image, utils } from 'services'
import { MaterialIcon } from 'controls'
import { Row, Col } from 'flexbox'
import getConfig from './heroConfiguration'

import { hero } from './styles'

export class Hero extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  }

  renderButton = (btn, index) => (
    <Button
      color={btn.color}
      outline={btn.outline}
      variation={btn.variation}
      key={`button-${index}`}
      href={btn.href}
      as={btn.asUrl}
    >
      <span style={btn.icon ? { marginRight: '0.5rem' } : {}}>{btn.title}</span>
      {btn.icon ? <MaterialIcon icon={btn.icon} className="large" /> : ''}
    </Button>
  )

  render() {
    const { title, subTitle, image: imageName, children, buttons } = this.props
    const style = {
      backgroundImage: `url("${image(imageName)}")`
    }

    return (
      <div style={{ width: '100%' }}>
        <div style={style} className="hero-container">
          <header className="text primary">{title}</header>
          <div className="text secondary">{subTitle}</div>
          {children && <div className="container-children">{children}</div>}
          <div className="buttons-container">
            {buttons.map(this.renderButton)}
          </div>
        </div>
        <style jsx>{hero}</style>
      </div>
    )
  }
}

const HeroWrapper = ({ type, children }) => (
  <Hero {...getConfig(type)} children={children} />
)

HeroWrapper.propTypes = {
  type: PropTypes.oneOf([
    'about',
    'homepage',
    'promoteYourProperties',
    'betterServeYourClients',
    'transactionManagement',
    'administrative',
    'help'
  ])
}

export default HeroWrapper
